import React, { useState } from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";

// Modal de exclusão de pipeline com confirmação por digitação: o botão de excluir
// só habilita quando o usuário digita o nome exato da pipeline. Centraliza a mesma
// cópia e a mesma chamada de API usadas na lista de pipelines e na página de
// edição, para que ambos os fluxos exijam a confirmação por digitação.
const PipelineDeleteModal = ({ pipeline, close, onDeleted }) => {
    const [text, setText] = useState("");
    const [deleting, setDeleting] = useState(false);

    if (!pipeline) return null;

    const confirmed = text.trim() === (pipeline.name ?? "").trim();

    const confirmDelete = () => {
        setDeleting(true);
        api.delete(`/pipeline/${pipeline.id}`).then(() => {
            toast.success("Pipeline excluída com sucesso");
            onDeleted();
        }).catch(error => {
            renderError(error);
        }).then(() => setDeleting(false));
    };

    return (
        <Modal
            className={`pipeline-delete-modal`}
            show={true}
            title={`Excluir pipeline`}
            close={() => { if (!deleting) close(); }}
            footer={
                <>
                    <Button
                        type={`primary`}
                        size={`small`}
                        svg={`delete-small-white`}
                        text={`Excluir pipeline`}
                        action={confirmDelete}
                        loading={deleting}
                        disabled={!confirmed}
                    />
                    {!deleting &&
                        <Button type={`secondary`} size={`small`} text={`Cancelar`} action={close} />
                    }
                </>
            }
        >
            <div className="section pipeline-delete">
                <p className="pipeline-delete__warning">
                    Esta ação é <strong>irreversível</strong>. A pipeline <strong>“{pipeline.name}”</strong> e todo o
                    seu conteúdo (etapas, cards e automações) deixarão de ficar acessíveis.
                </p>
                <p className="pipeline-delete__hint">
                    Para confirmar, digite o nome da pipeline: <strong>{pipeline.name}</strong>
                </p>
                <Input
                    value={text}
                    change={value => setText(value)}
                    placeholder={pipeline.name}
                />
            </div>
        </Modal>
    );
};

export default PipelineDeleteModal;
